import { derived, writable } from 'svelte/store';
import { configStore } from '#stores/configs/config.js';

export const attributesConfigStore = derived([configStore], ([$configStore]) => {
    return $configStore.attributes;
});

export const mediaMonitorAttributesConfigStore = derived([configStore], ([$configStore]) => {
    return $configStore.mediaMonitorAttributes;
});

export const mediaArticlesResponseStore = writable({});
